<div class="app-profile-container">
  <div class="app-profile-row">
    <div class="app-profile-title">
      <mat-icon class="app-profile-icon" (click)="navigateToPersonalFiles()">arrow_back</mat-icon>
      <h3 class="app-profile">{{'APP.EDIT_PROFILE.MY_PROFILE' | translate}}</h3>
    </div>
    <mat-divider class="app-mat-divider"></mat-divider>
  </div>
  <div class="app-profile-general-row" [formGroup]="profileForm">
    <div class="app-profile-general">
      <div class="app-profile-general-div">
        <mat-icon class="app-profile-general-icon" (click)="toggleGeneralDropdown()">
          {{ generalSectionDropdown ?  'expand_more' : 'chevron_right'}}</mat-icon>
        <h4 class="app-general-title">{{'APP.EDIT_PROFILE.GENERAL' | translate}}</h4>
      </div>
      <div class="app-general-edit-btn" *ngIf="generalSectionButtonsToggle && personDetails?.capabilities?.isMutable">
        <button mat-raised-button (click)="toggleGeneralButtons()"
          class="app-general-edit">{{'APP.EDIT_PROFILE.EDIT' | translate}}</button>
      </div>
      <div class="app-general-edit-btn" *ngIf="!generalSectionButtonsToggle">
        <button mat-raised-button class="app-general-cancel-btn"
          (click)="toggleGeneralButtons()">{{'APP.EDIT_PROFILE.CANCEL' | translate}}</button>
        <button mat-raised-button class="app-general-save-btn"
          (click)="onSaveGeneralData(profileForm)">{{'APP.EDIT_PROFILE.SAVE' | translate}}</button>
      </div>
    </div>
    <mat-divider class="app-mat-divider" *ngIf="generalSectionDropdown"></mat-divider>
    <div *ngIf="generalSectionDropdown">
      <div class="app-general-dropdown">
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.FIRST_NAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.firstName}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.LAST_NAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.lastName}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <!--<div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.JOB_TITLE' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="generalSectionButtonsToggle">{{personDetails?.jobTitle}}</p>
          <input type="text" value="" formControlName="jobTitle" *ngIf="!generalSectionButtonsToggle"
            class="app-profile-general-dropdown-input-details app-selected">
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.LOCATION' | translate}}</h4>
          <p class="app-profile-general-dropdown-details"  *ngIf="generalSectionButtonsToggle">{{personDetails?.location}}</p>
          <input type="text" value="" formControlName="location" *ngIf="!generalSectionButtonsToggle"
            class="app-profile-general-dropdown-input-details app-selected">
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.TELEPHONE' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="generalSectionButtonsToggle">{{personDetails?.telephone}}</p>
          <input type="tel" name="Telephone" value="" formControlName="telephone" *ngIf="!generalSectionButtonsToggle"
            class="app-profile-general-dropdown-input-details app-selected">
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.MOBILE' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="generalSectionButtonsToggle">{{personDetails?.mobile}}</p>
        <input type="tel" value="" formControlName="mobile" *ngIf="!generalSectionButtonsToggle"
          class="app-profile-general-dropdown-input-details app-selected">
        </div>-->
      </div>
    </div>
  </div>

  <form class="app-profile-login-row" [formGroup]="passwordForm">
    <div class="app-profile-login" >
      <div class="app-profile-general-div">
        <mat-icon class="app-profile-general-icon" (click)="toggleLoginDropdown()">
          {{ loginSectionDropdown ?  'expand_more' : 'chevron_right'}}</mat-icon>
        <h4 class="app-general-title">{{'APP.EDIT_PROFILE.LOGIN' | translate}}</h4>
      </div>

      <div class="app-general-edit-btn" *ngIf="loginSectionButtonsToggle && personDetails?.capabilities?.isMutable">
        <button mat-raised-button (click)="toggleLoginButtons()"
          class="app-general-edit">{{'APP.EDIT_PROFILE.EDIT' | translate}}</button>
      </div>
      <div class="app-general-edit-btn" *ngIf="!loginSectionButtonsToggle">
        <button mat-raised-button class="app-general-cancel-btn"
          (click)="toggleLoginButtons()">{{'APP.EDIT_PROFILE.CANCEL' | translate}}</button>
        <button mat-raised-button  class="app-general-save-btn"
          (click)="onSaveLoginData(passwordForm)">{{'APP.EDIT_PROFILE.SAVE' | translate}}</button>
      </div>
    </div>
    <mat-divider class="app-mat-divider" *ngIf="loginSectionDropdown"></mat-divider>
    <div class="app-profile-login-dropdown" *ngIf="loginSectionDropdown">
      <div class="app-general-dropdown" >
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.USERNAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.id}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.EMAIL' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.email}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider" *ngIf="!passwordSectionDropdown"></mat-divider>
        <div class="app-general-dropdown-details" *ngIf="!passwordSectionDropdown">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.PASSWORD' | translate}}</h4>
          <p class="app-profile-general-dropdown-details"></p>
        </div>
        <mat-divider class="app-general-dropdown-divider" *ngIf="passwordSectionDropdown"></mat-divider>
        <div class="app-general-dropdown-details" *ngIf="passwordSectionDropdown">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.OLD_PASSWORD' | translate}}</h4>
          <mat-form-field>
            <input matInput class="app-profile-login-dropdown-details app-selected" type="password" formControlName="oldPassword">
            <mat-error *ngIf="passwordForm.get('oldPassword').hasError('required') || passwordForm.get('oldPassword').invalid ">
              {{ getErrorMessage('oldPassword') }}
            </mat-error>
          </mat-form-field>
          <mat-icon (click)="getControlVisibility($event,'oldPassword')">visibility_off</mat-icon>
          <!--<h4 class="app-profile-login-dropdown-heading-forgot">{{'APP.EDIT_PROFILE.FORGOT_PASSWORD' | translate}}</h4>-->
        </div>
        <mat-divider class="app-general-dropdown-divider" *ngIf="passwordSectionDropdown"></mat-divider>
        <div class="app-general-dropdown-details app-password-dropdown-details" *ngIf="passwordSectionDropdown">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.NEW_PASSWORD' | translate}}</h4>
          <mat-form-field>
            <input matInput class="app-profile-login-dropdown-details app-selected" type="password" formControlName="newPassword" (blur)="verifyNewPassword()">
            <mat-error *ngIf="passwordForm.get('newPassword').hasError('required') || passwordForm.get('newPassword').invalid">
              {{ getErrorMessage('newPassword') }}
            </mat-error>
          </mat-form-field>
          <mat-icon (click)="getControlVisibility($event,'newPassword')">visibility_off</mat-icon>
        </div>
        <mat-divider class="app-general-dropdown-divider" *ngIf="passwordSectionDropdown"></mat-divider>
        <div class="app-general-dropdown-details app-password-dropdown-details" *ngIf="passwordSectionDropdown">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.VERIFY_PASSWORD' | translate}}</h4>
          <mat-form-field>
            <input matInput class="app-profile-login-dropdown-details app-selected" type="password" formControlName="verifyPassword" (blur)="verifyNewPassword()">
            <mat-error *ngIf="passwordForm.get('verifyPassword').hasError('required') || passwordForm.get('verifyPassword').invalid">
              {{ getErrorMessage('verifyPassword') }}
            </mat-error>
          </mat-form-field>
          <mat-icon (click)="getControlVisibility($event,'verifyPassword')">visibility_off</mat-icon>
        </div>
      </div>
    </div>
  </form>

  <!--<div class="app-profile-contact-row" [formGroup]="profileForm">
    <div class="app-profile-general profile-general-bottom-radius">
      <div class="app-profile-general-div">
        <mat-icon class="app-profile-general-icon" (click)="toggleContactDropdown()">
          {{ contactSectionDropdown ?  'expand_more' : 'chevron_right'}}</mat-icon>
        <h4 class="app-general-title">{{'APP.EDIT_PROFILE.COMPANY_DETAILS' | translate}}</h4>
      </div>

      <div class="app-general-edit-btn" *ngIf="contactSectionButtonsToggle && personDetails?.capabilities?.isMutable">
        <button mat-raised-button class="app-general-edit"
          (click)="toggleContactButtons()">{{'APP.EDIT_PROFILE.EDIT' | translate}}</button>
      </div>
      <div class="app-general-edit-btn" *ngIf="!contactSectionButtonsToggle">
        <button mat-raised-button class="app-general-cancel-btn"
          (click)="toggleContactButtons()">{{'APP.EDIT_PROFILE.CANCEL' | translate}}</button>
        <button mat-raised-button  class="app-general-save-btn"
          (click)="onSaveCompanyData(profileForm)">{{'APP.EDIT_PROFILE.SAVE' | translate}}</button>
      </div>
    </div>
    <mat-divider class="app-mat-divider" *ngIf="contactSectionDropdown"></mat-divider>
    <div *ngIf="contactSectionDropdown">
      <div class="app-general-dropdown" >
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.NAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.company?.organization}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider"></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.ADDRESS' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="contactSectionButtonsToggle">{{personDetails?.company?.address1}}</p>
          <input type="text" value="" *ngIf="!contactSectionButtonsToggle" formControlName="companyAddress"
            class="app-profile-general-dropdown-input-details app-selected">
        </div>
        <mat-divider class="app-general-dropdown-divider" ></mat-divider>
        <div class="app-general-dropdown-details" >
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.POST_CODE' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="contactSectionButtonsToggle">{{personDetails?.company?.postcode}}</p>
          <input type="text" value="" *ngIf="!contactSectionButtonsToggle" formControlName="companyPostCode"
            class="app-profile-general-dropdown-input-details app-selected">

        </div>
        <mat-divider class="app-general-dropdown-divider" ></mat-divider>
        <div class="app-general-dropdown-details" >
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.TELEPHONE' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="contactSectionButtonsToggle">{{personDetails?.company?.telephone}}</p>
          <input type="tel" value="" *ngIf="!contactSectionButtonsToggle" formControlName="companyTelephone"
            class="app-profile-general-dropdown-input-details app-selected">

        </div>
        <mat-divider class="app-general-dropdown-divider" ></mat-divider>
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.EMAIL' | translate}}</h4>
          <p class="app-profile-general-dropdown-details" *ngIf="contactSectionButtonsToggle">{{personDetails?.company?.email}}</p>
          <input type="text" value="" *ngIf="!contactSectionButtonsToggle" formControlName="companyEmail"
            class="app-profile-general-dropdown-input-details app-selected">
        </div>
      </div>
    </div>
  </div>-->
</div>
